import { AuthContext } from '@urbanx/agx.auth.client';
import { ContentLayout, PageLayout } from 'layout';
import { useContext } from 'react';
import { MonthEndReportView } from './MonthEndReportView';

const MonthEndPage = () => {
  const { userAccount } = useContext(AuthContext);
  return (
    <PageLayout
      agentName={userAccount?.firstName || ''}
      primaryPageTitle="Reporting"
      currentPageTitle="Month-end"
    >
      <ContentLayout>
        <MonthEndReportView />
      </ContentLayout>
    </PageLayout>
  );
};

export default MonthEndPage;
